var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-modal",
    {
      ref: "modalMigrationRol",
      attrs: {
        title: "Migrar del Rol: " + _vm.rol.nombre,
        "hide-footer": "",
        centered: "",
        "no-close-on-backdrop": "",
        "no-close-on-esc": "",
        size: "lg"
      }
    },
    [
      _c("b-overlay", { attrs: { show: _vm.isSaving } }, [
        _c("div", { staticClass: "row" }, [
          _c(
            "div",
            { staticClass: "col-md-12" },
            [
              _c("label", [_vm._v("Ambiente destino")]),
              _c("v-select", {
                attrs: {
                  multiple: "",
                  label: "title",
                  options: _vm.enviromentAvailable
                },
                model: {
                  value: _vm.enviromentSelected,
                  callback: function($$v) {
                    _vm.enviromentSelected = $$v
                  },
                  expression: "enviromentSelected"
                }
              })
            ],
            1
          ),
          _c("div", { staticClass: "col-md-12 mt-5" }, [
            _c(
              "button",
              {
                staticClass: "btn btn-primary",
                attrs: { disabled: _vm.enviromentSelected.length === 0 },
                on: { click: _vm.sendMigration }
              },
              [_vm._v(" Guardar ")]
            )
          ])
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }